export const ImagePlaceholder = () => {
    return (
        <svg
            width="135"
            height="135"
            viewBox="0 0 135 135"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="135" height="135" fill="white" />
            <rect x="14.5938" y="31.0134" width="106.723" height="72.419" rx="1" fill="#EEEEEE" />
            <rect x="19.6748" y="36.0955" width="96.5587" height="62.255" rx="1" fill="white" />
            <circle cx="51.4385" cy="56.4251" r="6.35255" fill="#EEEEEE" />
            <mask
                id="mask0_6134_244689"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="19"
                y="36"
                width="98"
                height="63"
            >
                <rect x="19.6748" y="36.0955" width="96.5587" height="62.255" rx="1" fill="white" />
            </mask>
            <g mask="url(#mask0_6134_244689)">
                <rect
                    x="87.3789"
                    y="52.6123"
                    width="65.3269"
                    height="65.3269"
                    rx="1"
                    transform="rotate(45 87.3789 52.6123)"
                    fill="#DFE0E1"
                />
                <rect
                    x="42.9102"
                    y="67.8584"
                    width="50.8204"
                    height="50.8204"
                    rx="1"
                    transform="rotate(45 42.9102 67.8584)"
                    fill="#F5F5F5"
                />
            </g>
        </svg>
    );
};
